// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3HRHr","buttons":"SendReceipts_buttons__1ljwS","email":"SendReceipts_email__2dwTD","bookApptTitle":"SendReceipts_bookApptTitle__1DfG8"};